import * as React from 'react';
import clsx from 'clsx';

import './style.scss';

/* eslint-disable-next-line */
export interface IButtonGroupProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    orientation?: 'vertical' | 'horizontal';
    noGaps?: boolean;
}

export type Ref = HTMLDivElement;
export const ButtonGroup = React.forwardRef<Ref, IButtonGroupProps>(
    ({ className, orientation = 'horizontal', noGaps = false, ...rest }, ref) => (
        <div
            className={clsx('oms-button-group', className, {
                'orientation-vertical': orientation === 'vertical',
                'orientation-horizontal': orientation === 'horizontal',
                'no-gaps': noGaps
            })}
            ref={ref}
            {...rest}
        />
    )
);
